<template>
  <header class="header-global">
    <base-nav class="navbar-main fixed-top navbar-expand-lg py-3 navbar-dark bg-default" type="" effect="light" expand>
      <a slot="brand" class="navbar-brand mr-lg-5" href="#">
        <img src="/img/brand/white.png" alt="logo" />
      </a>
      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand">
          <a href="#">
            <img src="/img/brand/blue.png"  alt="brand"/>
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>
      <div class="align-items-lg-center ml-lg-auto">
        <scrollactive
          active-class="nav-active"
          :offset="100"
          :duration="800"
          bezier-easing-value=".5,0,.35,1"
        >
          <ul class="navbar-nav">
            <li class="nav-item">
              <a href="#maps" class="nav-link scrollactive-item" data-toggle="dropdown" role="button">
                <span class="nav-link-inner--text">Prefeituras</span>
              </a>
            </li>
            <li class="nav-item">
              <a href="#estatisticas" class="nav-link scrollactive-item" data-toggle="dropdown" role="button">
                <span class="nav-link-inner--text">Estatísticas</span>
              </a>
            </li>
            <li class="nav-item">
              <a href="#informacoes" class="nav-link scrollactive-item" data-toggle="dropdown" role="button">
                <span class="nav-link-inner--text">Informações</span>
              </a>
            </li>
            <li class="nav-item">
              <a href="#servicos" class="nav-link scrollactive-item" data-toggle="dropdown" role="button">
                <span class="nav-link-inner--text">Serviços</span>
              </a>
            </li>
            <li class="nav-item">
              <a href="#nfse" class="nav-link scrollactive-item" data-toggle="dropdown" role="button">
                <span class="nav-link-inner--text">Nfse</span>
              </a>
            </li>
            <li class="nav-item">
              <a href="#contato" class="nav-link scrollactive-item" data-toggle="dropdown" role="button">
                <span class="nav-link-inner--text">Contato</span>
              </a>
            </li>
          </ul>
        </scrollactive>
      </div>
    </base-nav>
  </header>
</template>

<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>

<style lang="scss">

  .nav-active {
    color: #25ac92 !important;
  }

</style>
